'use client'

import { Typography } from "@mui/material";
import { FC } from "react";
import { TagBox } from "./styled";
import { useTranslations } from "next-intl";
import LockOutlineIcon from '@mui/icons-material/LockOutline';

export const DeactivatedTag: FC = () => {
  const t = useTranslations();

  return (
    <TagBox>
      <LockOutlineIcon />
      <Typography
        fontSize={15}
        fontWeight={700}
        textTransform={'uppercase'}
      >
        {t("deactivated")}
      </Typography>
    </TagBox>
  );
};
